import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Wraps any page/section that is a MOCKED integration placeholder.
 * Explicit visual disclosure per problem-statement requirement.
 */
export function PlaceholderBanner({ title, message, className }) {
  return (
    <div className={cn(
      "flex items-start gap-3 border border-dashed border-teal-300 bg-teal-50/40 rounded-sm p-3",
      className
    )}>
      <AlertCircle className="w-4 h-4 text-altara-teal mt-0.5 shrink-0" />
      <div className="text-xs">
        <div className="uppercase tracking-[0.15em] font-semibold text-altara-teal mb-1">
          {title || "Integration placeholder · MOCKED"}
        </div>
        <p className="text-slate-600">{message}</p>
      </div>
    </div>
  );
}
